import { endOfDay } from "date-fns";

import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";
import { isNotEmpty } from "@mapmycustomers/shared/util/assert";

import { ActivityPayload } from "@app/store/api/ApiService";
import { stringifyActivityInterval } from "@app/util/activity/activityInterval";

import FormValues from "../types/FormValues";

const getActivityPayloadFromCreationForm = (
  values: FormValues,
  activityTypes: ActivityType[],
  isMultiContactEnabled: boolean
): ActivityPayload => {
  const activityType = activityTypes.find(({ id }) => id === values.activityTypeId);
  let startAt = values.startAt;

  if (values.allDay && startAt) {
    startAt = endOfDay(startAt);
  }

  // Multi mode writes values.peopleIds; single mode writes values.personId.
  const peopleIds = isMultiContactEnabled
    ? (values.peopleIds ?? [])
    : values.personId
      ? [values.personId]
      : [];
  const primaryPersonId = peopleIds[0];

  return {
    account: values.companyId ? { id: values.companyId } : null,
    allDay: values.allDay,
    assigneeId: values.assignee?.id,
    ...(isNotEmpty(values.coachingNoteId) ? { coachingNoteId: values.coachingNoteId } : {}),
    completed: values.completed,
    contact: primaryPersonId ? { id: primaryPersonId } : null,
    ...(isMultiContactEnabled && peopleIds.length > 0
      ? { contacts: peopleIds.map((id) => ({ id })) }
      : {}),
    crmActivityType: { id: values.activityTypeId! },
    deal: values.dealId ? { id: values.dealId } : null,
    endAt: values.allDay ? undefined : values.endAt?.toISOString(),
    name: values.name || activityType?.name || "",
    note: values.note,
    recurInterval: stringifyActivityInterval(values.recurInterval),
    reminders: values.reminders,
    startAt: startAt?.toISOString(),
    ...(isNotEmpty(values.subjectUserId) ? { subjectUserId: values.subjectUserId } : {}),
    teamId: values.teamIds,
    visibility: values.visibility,
  };
};

export default getActivityPayloadFromCreationForm;
